export class ArrayHelper {

    static range(start, end): Array<number> {
        // @ts-ignore
        return Array(end - start + 1).fill().map((_, idx) => start + idx);
    }

    static rangeLenght(start, lenght): Array<number> {
        // @ts-ignore
        return Array(lenght).fill().map((_, idx) => start + idx);
    }
}
